/** #773 — immediate queue row selection push (WS path). */
import { useMaestroStore } from '../store/maestroStore';
import { createCommand, type CommandPayload } from '../protocols/BATON';
import { getCurrentPlaybackSnapshot } from '../transport/PlaybackSnapshot';

type SyncHandlerLike = {
  claimControl: () => void;
  _pushTimer: ReturnType<typeof setTimeout> | null;
  _deviceId: string;
  _deviceName: string;
  ws: WebSocket | null;
  isObserving: () => boolean;
  _lastPushFingerprint: string;
};

function mapQueueForSync(queue: unknown[]): unknown[] {
  return queue.slice(0, 200).map((item: any) => {
    const t = item?.track || item;
    const art = t.artworkUrl || t.artUrl || t.coverUrl || t.cover || t.imageUrl || t.artwork || '';
    const mapped: Record<string, unknown> = {
      id: t.id || '',
      title: t.title || '',
      artist: t.artist || '',
      album: t.album || '',
      artUrl: art,
      artworkUrl: art,
      albumId: t.albumId || t.album_key || t.albumKey || '',
      formatId: t.formatId || 27,
      qobuzTrackId: t.qobuzTrackId || t.serviceTrackId || '',
      duration: t.duration || 0,
      source: t.source || 'library',
    };
    if (t.source === 'local_library') {
      mapped.file_path = t.file_path || '';
      mapped.machine_id = t.machine_id || '';
      mapped.format = t.format || '';
    }
    return mapped;
  });
}

export function emitImmediateQueueSelection(
  handler: SyncHandlerLike,
  queueIndex: number,
  track: Record<string, unknown>,
): void {
  handler.claimControl();
  if (handler._pushTimer) {
    clearTimeout(handler._pushTimer);
    handler._pushTimer = null;
  }
  useMaestroStore.getState().setQueueIndex(queueIndex);
  const snap = getCurrentPlaybackSnapshot();
  const trackId = track.id ?? track.qobuzTrackId ?? track.serviceTrackId ?? '';
  const artworkUrl = track.artworkUrl || track.artUrl || track.coverUrl || '';
  if (!handler.ws || handler.ws.readyState !== WebSocket.OPEN || handler.isObserving()) return;
  const payload: Record<string, unknown> = {
    cmd: 'syncState',
    controllerId: handler._deviceId,
    deviceName: handler._deviceName,
    track: {
      id: trackId,
      title: track.title || '',
      artist: track.artist || '',
      album: track.album || '',
      artUrl: artworkUrl,
      artworkUrl,
      formatId: track.formatId || 27,
      qobuzTrackId: track.qobuzTrackId || track.serviceTrackId || '',
      duration: track.duration || 0,
      source: track.source || 'library',
    },
    playbackState: 'loading',
    position: snap.position,
    duration: track.duration || snap.duration,
    rendererId: snap.renderer?.id || null,
    rendererName: snap.renderer?.name || null,
    activeSource: 'library',
    queueIndex,
    queue: mapQueueForSync(snap.queue),
    volume: snap.volume,
    repeatMode: snap.repeatMode,
    shuffled: snap.shuffled,
    clientSelectionAt: Date.now(),
    ts: Date.now(),
  };
  handler.ws.send(JSON.stringify(createCommand('transport' as never, payload as CommandPayload)));
  handler._lastPushFingerprint =
    `${snap.activeSource}|${trackId}|${queueIndex}|loading|${snap.queue.length}|${snap.renderer?.id || 'local'}`;
  console.log('[SyncHandler] Immediate queue selection push index', queueIndex, track.title || trackId);
}
